import type { WorkspaceDesk } from '@/config/workspace-desk'

/** Build the origin URL for [desk] using the current host's domain suffix (e.g. pro.amglobal.co). */
export function deskPortalOrigin(desk: WorkspaceDesk, currentHost: string = window.location.host): string {
  const hostPart = currentHost.split(':')[0]?.trim().toLowerCase() ?? ''
  const portSep = currentHost.indexOf(':')
  const port = portSep >= 0 ? currentHost.slice(portSep) : ''

  const labels = hostPart.split('.')
  if (labels.length >= 2) {
    labels[0] = desk
    return `${window.location.protocol}//${labels.join('.')}${port}`
  }

  return window.location.origin
}

/** True when the host has a desk subdomain (not localhost). */
export function isDeskHost(host: string = window.location.hostname): boolean {
  const normalized = host.split(':')[0]?.trim().toLowerCase() ?? ''
  if (!normalized || normalized === 'localhost' || normalized === '127.0.0.1') {
    return false
  }
  return normalized.split('.').length >= 2
}
